import { Route } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { BaseLayout, PageNotFound, UnsavedChangesGuard } from '@ottobock/remote-update/domain';
import {
  Device,
  DeviceDetails,
  FirmwarePackageDetails,
  FirmwarePage,
  RolloutPlan,
  RolloutPlanDetails
} from '@ottobock/remote-update/feature-remote-update-dashboard';
import { RemoteUpdateDetailsComponent } from '@ottobock/remote-update/feature-remote-update-details';

export const appRoutes: Route[] = [
  { path: 'signin-oidc', component: MsalRedirectComponent },

  {
    path: '',
    component: BaseLayout,
    canActivate: [MsalGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'all-devices' },

      { path: 'all-devices', component: Device, canDeactivate: [UnsavedChangesGuard] },
      { path: 'all-devices/details/:id', component: DeviceDetails },

      { path: 'rollout-plan', component: RolloutPlan, canDeactivate: [UnsavedChangesGuard] },
      {
        path: 'rollout-plan/details/:id',
        component: RolloutPlanDetails,
        canDeactivate: [UnsavedChangesGuard]
      },

      { path: 'firmware-package', component: FirmwarePage, canDeactivate: [UnsavedChangesGuard] },
      {
        path: 'firmware-package/details/:id',
        component: FirmwarePackageDetails,
        canDeactivate: [UnsavedChangesGuard]
      },

      {
        path: 'details/:id',
        component: RemoteUpdateDetailsComponent,
        canDeactivate: [UnsavedChangesGuard]
      },
      { path: '**', component: PageNotFound }
    ]
  }
];
